import { render, staticRenderFns } from "./AIChatWidgetTemplateGallery.vue?vue&type=template&id=23fac643&scoped=true"
import script from "./AIChatWidgetTemplateGallery.vue?vue&type=script&lang=js"
export * from "./AIChatWidgetTemplateGallery.vue?vue&type=script&lang=js"
import style0 from "./AIChatWidgetTemplateGallery.vue?vue&type=style&index=0&id=23fac643&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23fac643",
  null
  
)

export default component.exports